<template>
  <div style="margin: 0.1rem 0.11rem 0;" class="setting">
    <ul class="infoHead">
      <li @click="goAddress">
        <b>我的地址</b>
        <div class="infolistRight">
          <img class="jt" src="../../assets/images/jt2.png" />
        </div>
      </li>
      <li @click="phone">
        <b>{{ mobile ? '更换手机号' : '绑定手机号' }}</b>
        <div class="infolistRight">
          <!--mobile.slice(3, 7)-->
          <p v-if="mobile">
            {{ mobile.slice(0, 3) }}&nbsp;****&nbsp;{{ mobile.slice(7, 11) }}
          </p>
          <img class="jt" src="../../assets/images/jt2.png" />
        </div>
      </li>
    </ul>
    <ul class="infoHead">
      <li @click="clear">
        <b>清除缓存</b>
        <div class="infolistRight">
          <img class="jt" src="../../assets/images/jt2.png" />
        </div>
      </li>
      <li @click="help">
        <b>问题帮助</b>
        <div class="infolistRight">
          <p>使用上的疑惑来这里找</p>
          <img class="jt" src="../../assets/images/jt2.png" />
        </div>
      </li>
    </ul>
    <div class="settingClose" v-if="wapShow" @click="logout">
      退出登录
    </div>
  </div>
</template>

<script>
import {
  basepath,
  isWeixin,
  clearAllCookie,
  fenxiang,
  wxAjaxData,
  exclusiveidFn,
  pointParams,
  meetingidFn
} from '../../assets/common/js/config'

export default {
  name: 'setting',
  data() {
    return {
      mobile: '',
      wapShow: false
    }
  },
  mounted() {
    if (isWeixin()) {
      fenxiang({ path: 'setting' })
    }
    this.isWap()
    if (sessionStorage.getItem('ckys4_mobile')) {
      this.mobile = sessionStorage.getItem('ckys4_mobile')
    }
    // 挂载完成后，判断浏览器是否支持popstate
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.goBack, false)
    }
  },
  destroyed() {
    this.$toast.clear()
    this.$dialog.close()
    window.removeEventListener('popstate', this.goBack, false)
  },
  methods: {
    isWap: function() {
      if (isWeixin()) {
        this.wapShow = false
      } else {
        this.wapShow = true
      }
    },
    phone: function() {
      if (this.mobile != '') {
        this.$router.push('/phone')
      } else {
        sessionStorage.removeItem('ckys_wx_bound_tel')
        sessionStorage.removeItem('ckys_wx_bound_area_code')
        this.$router.push('/bound')
      }
    },
    goBack() {
      // 个人中心进入返回上一级，支付后进入返回首页
      if (this.$route.query.route) {
        this.$router.replace({ path: '/' })
      } else {
        history.go(-1)
      }
    },
    clear: function() {
      var that = this
      if (isWeixin()) {
        sessionStorage.clear()
        localStorage.clear()
        clearAllCookie()
        console.log(wxAjaxData)
        location.href = basepath + 'Wxmall/WeChat/clearCookie' + wxAjaxData
      } else {
        sessionStorage.clear()
        localStorage.clear()
        that.$toast({
          message: '清除成功',
          icon: require('../../assets/images/succ.png')
        })
        setTimeout(function() {
          that.$router.replace(
            '/?exclusiveid=' +
              exclusiveidFn() +
              pointParams('&') +
              '&meetingid=' +
              meetingidFn()
          )
        }, 100)
      }
    },
    help() {
      this.$router.push('/help')
    },
    goAddress: function() {
      this.$router.push('/addmana')
    },
    logout: function() {
      this.$dialog
        .confirm({
          title: '确定退出登录？',
          className: 'collect_button_alert',
          cancelButtonColor: '#FC0324',
          confirmButtonColor: '#FFFCFC',
          confirmButtonText: '确定'
        })
        .then(() => {
          // on confirm
          sessionStorage.clear()
          localStorage.clear()
          clearAllCookie()
          window.location.href = '/'
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>

<style scoped lang="scss">
.infoHead {
  border-radius: 0.04rem;
  margin-bottom: 0.11rem;
  background: #fff;
  li {
    color: #b0b0b0;
    font-size: 0.13rem;
    border-bottom: 1px solid #efefef;
    height: 0.45rem;
    margin: 0 0.15rem;
    position: relative;
    .dataComp {
      position: absolute;
      right: -0.26rem;
      top: 0;
      text-align: center;
      background: linear-gradient(90deg, #ffde4a 0%, #fff848 60%, #faef1c 100%);
      background: -webkit-linear-gradient(
        90deg,
        #ffde4a 0%,
        #fff848 60%,
        #faef1c 100%
      );
      background: -moz-linear-gradient(
        90deg,
        #ffde4a 0%,
        #fff848 60%,
        #faef1c 100%
      );
      background: -o-linear-gradient(
        90deg,
        #ffde4a 0%,
        #fff848 60%,
        #faef1c 100%
      );
      background: -ms-linear-gradient(
        90deg,
        #ffde4a 0%,
        #fff848 60%,
        #faef1c 100%
      );
      border-radius: 1rem 0 0 1rem;
      padding: 0.01rem 0.06rem 0.03rem 0.12rem;
      p {
        font-size: 0.11rem;
        color: #895808;
      }
      b {
        font-size: 0.08rem;
        color: #a36e18;
      }
    }
  }
  & li,
  & .infolistRight {
    display: flex;
    display: -webkit-flex;
    display: -ms-flex;
    display: -o-flex;
    display: -moz-flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-justify-content: space-between;
    -o-justify-content: space-between;
    -moz-justify-content: space-between;
    align-items: center;
    -webkit-align-items: center;
    -ms-align-items: center;
    -o-align-items: center;
    -moz-align-items: center;
  }
  b {
    font-size: 0.15rem;
    color: #444444;
    display: block;
    font-weight: 600;
  }
  img {
    display: block;
  }
  .infolistRight {
    p {
      font-size: 0.13rem;
      color: #999999;
    }
    .jt {
      width: 0.06rem;
      height: 0.11rem;
      margin-left: 0.07rem;
    }
  }
}
.settingClose {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0.49rem;
  font-size: 0.17rem;
  font-weight: 400;
  color: rgba(211, 69, 68, 1);
  line-height: 0.49rem;
  background: #ffffff;
  text-align: center;
  &:active {
    background: #eee;
  }
}
</style>
<style>
.infoHead .van-icon__image {
  width: 0.36rem;
  height: 0.36rem;
}
</style>



// WEBPACK FOOTER //
// src/components/user/setting.vue